
const contentview = [{"key":"contentview.title","string":"Vsebina, ki ste jo dodali v repozitorij"},{"key":"contentview.add_content_button","string":"Dodaj vsebino"},{"key":"contentview.no_content_added","string":"Niste še dodali nobene vsebine v repozitorij."},{"key":"contentview.table.title","string":"Naslov"},{"key":"contentview.table.author","string":"Avtor"},{"key":"contentview.table.year","string":"Leto"},{"key":"contentview.full_text","string":"Pojdi na celotno besedilo"}]

export default contentview



// WEBPACK FOOTER //
// ./src/i18n/sl/addcontent/contentview.js